module.exports = __webpack_public_path__ + "static/media/VC.60113cb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/VC.svg
// module id = 2287
// module chunks = 7